import AboutSort from "components/AboutSort";
import SearchRoom from "components/SearchRoom/SearchRoom";
import Services from "components/Services";
import SimpleSlider from "components/Slider/SimpleSlider";
import VideoPlayer from "components/VideoPlayer";
import React from "react";
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();
  return (
    <>
               <SearchRoom/>
        <SimpleSlider />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="fade-in">
              </div>
            </div>
          </div>
        </div>
      <AboutSort />
      <VideoPlayer/>
      <Services />
    </>
  );
};

export default Home;
